import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Σύστημα Διαχείρισης Επαφών';
  public constructor(private titleService: Title ) {
    this.titleService.setTitle( this.title );
   }

  public setTitle( newTitle: string) {
    this.titleService.setTitle( newTitle );
  }

}
